<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="日历名称">
              <a-select v-model="queryParams.calendarId" @change="calendarIdOnChange">
                <a-select-option v-for="(item) in calendarIdList" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="说明">
              <a-input v-model="queryParams.description" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:routingCalendar:add']">新增</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->

        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          :pagination="false"
          :scroll="{ x: scrollWdith }"
          row-key="id"
        >
          <template slot="calendarName" slot-scope="text, record">
            <router-link :to="`/workCalendar/detail/${record.id}`">{{ text }}</router-link>
          </template>
          <template slot="description" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-if="isEdit && currentId === record.id" v-model="record.description" />
          </template>
          <template slot="days" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-checkbox-group v-if="isEdit && currentId === record.id" v-model="record.daysValues" :options="plainOptions" />
          </template>
          <template slot="shiftsNames" slot-scope="text, record">
            <span v-if="!isEdit || currentId !== record.id">{{ record.shiftsNames }}</span>
            <a-select
              v-if="isEdit && currentId === record.id"
              v-model="record.shiftsHeadIdList"
              mode="multiple"
              :max-tag-text-length="1"
              :max-tag-count="1"
              :max-tag-placeholder="() => {
                return '...'
              }">
              <a-select-option v-for="(item) in shiftsHeadIdListOption" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <span slot="operation" slot-scope="text, record">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['bom:routingCalendar:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.WORK_CALENDAR_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="calendarName" slot-scope="{ text, record }">
            <a @click="handleDetail(record)">{{ text }}</a>
          </template>
          <template slot="description" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text }}</span>
            <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record.description" />
          </template>
          <template slot="days" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.text }}</span>
            <a-checkbox-group v-if="isEdit && currentId === text.record.id" v-model="text.record.daysValues" :options="plainOptions" @change="handleForceUpdate"/>
          </template>
          <template slot="shiftsNames" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.shiftsNames }}</span>
            <a-select
              v-if="isEdit && currentId === text.record.id"
              v-model="text.record.shiftsHeadIdList"
              mode="multiple"
              :max-tag-count="1"
              :max-tag-placeholder="() => {
                return '...'
              }"
              @change="handleForceUpdate">
              <a-select-option v-for="(item) in shiftsHeadIdListOption" :key="item.realValue">{{ item.label }}</a-select-option>
            </a-select>
          </template>
          <template slot="updateTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="text">
            <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:routingCalendar:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== text.record.id" class="ml10" @click="handleRemove(text.record)">删除</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <!-- 创建/编辑快码,单独封装了组件 -->
        <work-calendar-add
          ref="createModal"
          :calendarIdList="calendarIdList"
          :shiftsHeadIdListOption="shiftsHeadIdListOption"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiRoutingCalendarPullDownList, apiRoutingCalendarShiftsPullDownList, apiRoutingCalendarEditCalendar, apiRoutingCalendarList, apiRoutingCalendarDelete } from '@/api/mes/calendar/workCalendar'
import WorkCalendarAdd from './components/work-calendar-add'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  name: 'WorkCalendar',
  components: {
    WorkCalendarAdd
  },
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiRoutingCalendarList, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: true,
        pageUrl: '/bom/routingCalendar/list',
        tableLoading: false
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {
        calendarId: undefined,
        description: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '日历名称',
          width: 250,
          dataIndex: 'calendarName',
          scopedSlots: { customRender: 'calendarName' },
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'description',
          ellipsis: true,
          width: 200,
          scopedSlots: { customRender: 'description' },
          align: 'center'
        },
        {
          title: '工作日历模式',
          dataIndex: 'days',
          width: 200,
          scopedSlots: { customRender: 'days' },
          align: 'center'
        },
        {
          title: '班次名称',
          dataIndex: 'shiftsNames',
          scopedSlots: { customRender: 'shiftsNames' },
          width: 200,
          align: 'center'
        },
        {
          title: '创建人',
          width: 120,
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '最后修改人',
          width: 120,
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      calendarIdList: [], // 日历名称
      shiftsHeadIdListOption: [], // 班次名称
      // 工作日历模式
      plainOptions: [
        { label: '星期一', value: 'monday' },
        { label: '星期二', value: 'tuesday' },
        { label: '星期三', value: 'wednesday' },
        { label: '星期四', value: 'thursday' },
        { label: '星期五', value: 'friday' },
        { label: '星期六', value: 'saturday' },
        { label: '星期日', value: 'sunday' }
      ],
      scrollWdith: 1400
    }
  },
  created () {
    this.getCalendarIdList()
    this.getShiftsHeadIdList()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 跳转日历详情
    handleDetail (record) {
      this.$router.push({ name: `work-calendar-detail`, query: { id: record.id } })
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
     const searchDB = this.$refs.dataTable.getData();
     searchDB.then(res => {
        this.getList(res.data.data.records)
      })
    },
    // 班次名称
    getShiftsHeadIdList () {
      apiRoutingCalendarShiftsPullDownList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.shiftsHeadIdListOption = res.data
        }
      })
    },
    // 日历名称
    calendarIdOnChange (val) {
      this.queryParams.description = this.calendarIdList.find(item => val === item.realValue).bringOutDataOne
    },
    // 日历名称
    getCalendarIdList () {
      apiRoutingCalendarPullDownList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.calendarIdList = res.data
        }
      })
    },
    /** 查询快码类型列表 */
    getList (data) {
      data.forEach(element1 => {
        const arr = []
        const arr2 = []
        element1.bomRoutingShiftsHeadVoList && element1.bomRoutingShiftsHeadVoList.forEach(element2 => {
          arr.push(element2.shiftsName)
          arr2.push(element2.id)
        });
        element1.shiftsNames = arr.join()
        element1.shiftsHeadIdList = arr2
        const arr1 = []
        const arr3 = []
        if (element1.monday === "Y") {
          arr1.push("一")
          arr3.push("monday")
        }
        if (element1.tuesday === "Y") {
          arr1.push("二")
          arr3.push("tuesday")
        }
        if (element1.wednesday === "Y") {
          arr1.push("三")
          arr3.push("wednesday")
        }
        if (element1.thursday === "Y") {
          arr1.push("四")
          arr3.push("thursday")
        }
        if (element1.friday === "Y") {
          arr1.push("五")
          arr3.push("friday")
        }
        if (element1.saturday === "Y") {
          arr1.push("六")
          arr3.push("saturday")
        }
        if (element1.sunday === "Y") {
          arr1.push("日")
          arr3.push("sunday")
        }
        element1.days = arr1.join()
        element1.daysValues = arr3
      });
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        calendarId: undefined,
        description: undefined
      }
      this.handleQuery()
    },
    editStatus () {
      this.scrollWdith = 1600
      const arr = JSON.parse(JSON.stringify(this.columns))
      arr[2].width = 400
      this.columns = arr
    },
    noEditStatus () {
      this.scrollWdith = 1400
      const arr = JSON.parse(JSON.stringify(this.columns))
      arr[2].width = 200
      this.columns = arr
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.editStatus()
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 删除工作日历
    handleRemove (record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 id为${record.id}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiRoutingCalendarDelete(record.id).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.daysValues || record.daysValues.length === 0 || !record.shiftsHeadIdList || record.shiftsHeadIdList.length === 0) {
        this.$message.warning('必填项不能为空')
        return;
      }
      const obj = {
        monday: "N",
        tuesday: "N",
        wednesday: "N",
        thursday: "N",
        friday: "N",
        saturday: "N",
        sunday: "N"
      }
      record.daysValues.forEach(element => {
        obj[element] = "Y"
      });
      const params = Object.assign(record, obj)
      params.calendarId = params.id
      apiRoutingCalendarEditCalendar(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.noEditStatus()
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.noEditStatus()
      this.onSearch()
    },
    // 工作日历模式勾选框和班次名称编辑时无反应，暂时将组件进行刷新以让组件有正确反馈
    handleForceUpdate () {
      this.$forceUpdate();
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  input {
    width: 150px;
  }
  /deep/.ant-select{
    width: 140px;
  }
}
</style>
